import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { tap } from 'rxjs';
import { AuditTypeResult } from 'src/app/core-module/models/AuditTypes/audit-type-result';
import { FlattenedQuestionHolder } from 'src/app/core-module/models/Audits/flattened-question-holder';
import { Question } from 'src/app/core-module/models/Audits/question';
import { DDL } from 'src/app/core-module/models/ddl';
import { AuditService } from 'src/app/core-module/services/audit.service';

@Component({
    selector: 'app-edit-questions',
    templateUrl: './edit-questions.component.html',
    styleUrls: ['./edit-questions.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditQuestionsComponent {
  @Input() public audit: FlattenedQuestionHolder;
  @Input() public newAudit: boolean = false;
  @Output() auditChange: EventEmitter<FlattenedQuestionHolder> = new EventEmitter<FlattenedQuestionHolder>();

  public questionTypes: DDL[] = [];
  public isEditingMode:boolean = false;  



  auditChanged() {
    this.auditChange.emit(this.audit);
  }

  updateEditMode(question:Question){
    var q = this.audit.Questions.find(e=>{
      return e.QuestionID == question.QuestionID;
    })!
    q.IsCurrentEdit = !q.IsCurrentEdit;   

    var isEditing = false;
    this.audit.Questions.forEach(e=>{
      if(e.IsCurrentEdit){
        isEditing = true;
      }
    })
    this.isEditingMode = isEditing;
  }

  constructor(public audits: AuditService) {
    audits.getQuestionTypes().pipe(
      tap((res:AuditTypeResult) => {
        this.questionTypes = this.questionTypes.concat(res.Results);
      })
    ).subscribe();
  }

  addQuestion() {
    let lastSeq = 1
    if (this.audit.Questions.length != 0) {
      lastSeq = this.audit.Questions[this.audit.Questions.length - 1].Seq;
    }
    //let lastSeq = this.audit.Questions[this.audit.Questions.length-1].Seq;
    let headingType = this.questionTypes.filter(e => { return e.ID == 6 })[0];
    this.audit.Questions.push(new Question({ QuestionID: -1, QuestionHeader: "New Question", QuestionType: headingType, Seq: lastSeq + 1, GUID: crypto.randomUUID(),IsCurrentEdit:true,InitialQuestion:true,AdvancedMaxScore:false,ComplianceLimit:-1,MaxScore:-1 }));
    this.isEditingMode = true;
    this.auditChanged();
  }
  duplicateQuestion(question: Question) {
    var ix = this.audit.Questions.findIndex(e => e.GUID == question.GUID);
    if (ix != -1) {
      var newQuestion = new Question(question);
      this.audit.Questions.forEach(e => {
        if (e.Seq > question.Seq) {
          e.Seq = e.Seq++;
        }
      });
      newQuestion.Seq++;
      newQuestion.QuestionID = -1;
      newQuestion.QuestionAnswers.forEach(e => { e.QuestionAnswerID = -1 });
      newQuestion.QuestionHeader = question.QuestionHeader + " (Copy)";
      this.audit.Questions.splice(ix + 1, 0, newQuestion);
    }
  }

  deleteQuestion(question: Question) {
    if (question.QuestionID == -1) {
      this.audit.Questions.splice(this.audit.Questions.findIndex(e => { return e.GUID == question.GUID }), 1);
    } else {
      question.Active = false;
    }
    this.auditChanged();
  }
  drop(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.audit.Questions, event.previousIndex, event.currentIndex);
    this.sequenceQuestions();
    this.auditChanged();
  }
  sequenceQuestions() {
    var seq:number = 1;
    this.audit.Questions.forEach(e=>{
      e.Seq = seq;
      seq++;
    })
  }
}
